import Footer from "../../components/Footer";
import PG_1 from "../../assets/img/pg_1.png";
import CRE_1 from "../../assets/img/cre_1.png";
import CRE_2 from "../../assets/img/cre_2.png";
import PG_2 from "../../assets/img/pg_2.png";
import PG_3 from "../../assets/img/pg_3.png";
import "../style.css";
import { useParams } from "react-router-dom";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
export default function CreativeProtfolioGuidance() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "Creative Portfolio Guidance",
      desc: "Unlock your creative potential with the Art and Design Service, guiding you through the Global art school application process with expert portfolio advice from a practising art academic.",
      img: CRE_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Successfully applying to study art and design in the the Global",
      desc: "The Global has long been a global leader in art and design, with a rich creative heritage that spans from 11th-century architecture to contemporary fine arts. Studying in the Global offers aspiring artists an unparalleled opportunity to immerse themselves in an innovative environment, learning from practising artists and expert academics across a wide range of disciplines. Gaining admission to specialist art schools in the Global is a competitive process, with stringent entry criteria and portfolio requirements. At Global StudyIn, we help students navigate this journey by providing expert guidance and personalised support. Our art and design portfolio review and preparation sessions offer aspiring artists the chance to refine their work with insights from a practising artist.",
    },
    thirdSection: {
      rightSection: {
        img: CRE_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Art and Design Service will do the following to maximise your chance of securing an offer:",
      },
      leftColumnContent: [
        {
          title: "Advice",
          description:
            "We help you research best-fit creative programmes and choose courses that match your interests",
        },
        {
          title: "Document checklist",
          description:
            "We help you put together the documents required by universities for entry",
        },
        {
          title: "Pre-screening",
          description:
            "We review your academic transcripts, CV, and reference letters, sharing suggestions for improvement",
        },
        {
          title: "Portfolio review",
          description:
            "We host a 90-minute portfolio review session with a qualified art and design professional",
        },
        {
          title: "Application support",
          description:
            "We help you fill in the university application forms and track your application after submission",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Creative Portfolio Guidance",
      desc: "Unlock your creative potential with the Art and Design Service, guiding you through the Global art school application process with expert portfolio advice from a practising art academic.",
      img: CRE_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Successfully applying to study art and design in the the Global",
      desc: "The Global has long been a global leader in art and design, with a rich creative heritage that spans from 11th-century architecture to contemporary fine arts. Studying in the Global offers aspiring artists an unparalleled opportunity to immerse themselves in an innovative environment, learning from practising artists and expert academics across a wide range of disciplines. Gaining admission to specialist art schools in the Global is a competitive process, with stringent entry criteria and portfolio requirements. At Global StudyIn, we help students navigate this journey by providing expert guidance and personalised support. Our art and design portfolio review and preparation sessions offer aspiring artists the chance to refine their work with insights from a practising artist.",
    },
    thirdSection: {
      rightSection: {
        img: CRE_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Art and Design Service will do the following to maximise your chance of securing an offer:",
      },
      leftColumnContent: [
        {
          title: "Advice",
          description:
            "We help you research best-fit creative programmes and choose courses that match your interests",
        },
        {
          title: "Document checklist",
          description:
            "We help you put together the documents required by universities for entry",
        },
        {
          title: "Pre-screening",
          description:
            "We review your academic transcripts, CV, and reference letters, sharing suggestions for improvement",
        },
        {
          title: "Portfolio review",
          description:
            "We host a 90-minute portfolio review session with a qualified art and design professional",
        },
        {
          title: "Application support",
          description:
            "We help you fill in the university application forms and track your application after submission",
        },
      ],
      rightColumnContent: [],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };
  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;


  return (
    <div className="personalised-guidance creative-portfolio">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
